function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.773.004L7.047 0c1.903.042 3.48 1.588 3.58 3.574a3.9 3.9 0 010 .393 6.8 6.8 0 01-1.022 4.055C7.868 8.22 7 9.713 7 11c0 .515.247 1.082.554 1.599.318.535.745 1.091 1.195 1.605.243.278.495.546.745.796H1.836l-.214-.012A1.853 1.853 0 010 13.138c0-.21.035-.42.104-.617l.08-.194.113-.21c.54-.889 1.648-1.515 3.497-2.261L4.7 9.5c.107-.31.104-.65-.01-.959a6.754 6.754 0 01-1.388-4.576C3.196 1.886 4.75.113 6.773.004z",
  fill: "url(#FitScore_svg__paint0_linear_25_28736)"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 16c-1-.5-4-3.5-4-5a2 2 0 114 0 2 2 0 014 0c0 1.5-3 4.5-4 5z",
  fill: "#EA3927"
});

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "FitScore_svg__paint0_linear_25_28736",
  x1: -5.321,
  y1: 7.5,
  x2: 8.837,
  y2: 17.544,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#4DB1FD"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#148CFC"
})));

var SvgFitScore = function SvgFitScore(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default SvgFitScore;